import request from '../utils/request'

const userService = {
  // 获取用户列表
  getList: (params) => {
    return request({
      url: '/user',
      method: 'get',
      params
    })
  },
  
  // 获取用户详情
  getById: (id) => {
    return request({
      url: `/user/${id}`,
      method: 'get'
    })
  },
  
  // 创建用户
  create: (data) => {
    return request({
      url: '/user',
      method: 'post',
      data
    })
  },
  
  // 更新用户
  update: (id, data) => {
    return request({
      url: `/user/${id}`,
      method: 'put',
      data
    })
  },
  
  // 删除用户
  delete: (id) => {
    return request({
      url: `/user/${id}`,
      method: 'delete'
    })
  },
  
  // 分配角色
  assignRoles: (userId, roleIds) => {
    return request({
      url: `/user/${userId}/roles`,
      method: 'post',
      data: { roleIds }
    })
  },

  //获取租户下所有用户列表
  getUsersByTenantId: (tenantId) => {
    return request({
      url: '/user/tenantAll',
      method: 'post',
      data: {tenantId}
    })
  },

  // 修改密码
  updatePassword: (data) => {
    return request({
      url: '/user/updatePassword',
      method: 'post',
      data
    })
  },
}

export default userService
